<nav class="fixed z-10 top-0 w-screen shadow bg-blumine">
  <div class="px-8 mx-auto bg--header">
    <div class="flex justify-between items-center h-20">
      <!-- Logo -->
      <div class="logo"></div>

      <!-- Group Buttons -->
      <div class="flex items-center ml-4">
        <!-- <button class="p-1 text-black bg-white rounded-full focus:outline-none hover:bg-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
        </button>

        <button class="p-1 ml-3 text-black bg-white rounded-full focus:outline-none hover:bg-gray-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            stroke-width=""
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        </button>

        <button class="p-1 ml-3 text-black bg-white rounded-full focus:outline-none hover:bg-gray-200">
          <svg
            class="w-6 h-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button> -->

        <!-- <span class="block mx-4 border-l border-white py-7"></span> -->
        <app-profile></app-profile>
      </div>
    </div>
  </div>
  <ul
    class="flex gap-2 p-2 items-center overflow-x-auto overflow-y-hidden pb-1 w-full navbar"
    [ngClass]="{ 'lg:justify-center': menuAmount < 6 && !isAdmin }"
    style="scrollbar-width: thin !important"
  >
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'dashboard.view']"
      label="Dashboard"
      route="dashboard"
      icon="overview"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Doctor, 'appointments.switchdoctor']"
      label="Agenda"
      route="agenda"
      icon="calendar_custom"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="isAdmin ? [] : [ERoleAdminString.Doctor, 'appointments.list']"
      label="Solicitações de consultas"
      route="consultas"
      icon="appointments"
      [hasNotification]="hasConsultasPendentes$ | async"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="isAdmin ? [] : [ERoleAdminString.Doctor, 'appointments.list']"
      label="Consultas Agendadas"
      route="proximas-consultas"
      icon="next-appointment"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Doctor, 'appointments.list']"
      label="Histórico de Consultas"
      route="historico"
      icon="previous-appointment"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Doctor, 'sicknote.list']"
      label="Atestados"
      route="atestados"
      icon="articles"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'partner.list']"
      label="Parceiros"
      route="parceiros"
      icon="doctors"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'company.list']"
      label="Empresas"
      route="empresas"
      icon="doctors"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'reason.list']"
      label="Motivos de atendimento"
      route="motivos-atendimento"
      icon="info"
    ></app-navbar-link>
    <app-navbar-link *isAllowed="['subsidiary.list']" label="Filiais" route="filiais" icon="contacts"></app-navbar-link>
    <app-navbar-link
      *isAllowed="['costcenter.list']"
      label="Centros de Custo"
      route="centro-custos"
      icon="ideas"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="['user-support.list', ERoleAdminString.Doctor]"
      label="Atendimento"
      route="user-support"
      icon="agents"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'employee.list']"
      label="Colaboradores"
      route="colaboradores"
      icon="agents"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'doctor.list']"
      label="Médicos"
      route="medicos"
      icon="doctor"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'device.list']"
      label="Dispositivos"
      route="dispositivos"
      icon="settings"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin]"
      label="Setups"
      route="setups"
      icon="settings"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin]"
      label="Catalogo de Produtos"
      route="catalogo-produtos"
      icon="file-text"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'queue.list']"
      label="Filas"
      route="filas"
      icon="contacts"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'role.list']"
      label="Perfil"
      route="papeis"
      icon="doctors"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'adminuser.list']"
      label="Usuários Admin"
      route="usuarios-admin"
      icon="supervisor_account_white"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'attendants.list']"
      label="Atendentes"
      route="atendentes"
      icon="supervisor_account_white"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'reports.list']"
      label="Relatórios de Atendimentos"
      route="relatorios"
      icon="supervisor_account_white"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'dashboard.list']"
      label="BI"
      route="my-dashboard"
      icon="overview"
    ></app-navbar-link>
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, 'settings.view']"
      label="Configurações"
      route="temas"
      icon="settings"
    ></app-navbar-link>
    <!-- <app-navbar-link  *isAllowed="[ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin, 'questionnaire.list']" label="Questionários" route="questionarios" icon="questionario"></app-navbar-link> -->
    <app-navbar-link
      *isAllowed="[ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin, 'questionnaire.edit']"
      label="Questionários Personalizados"
      route="questionarios/personalizados"
      icon="questionario"
    ></app-navbar-link>
    <!-- <app-navbar-link  *isAllowed="[ERoleAdminString.Admin, 'configuracao']" label="Configurações" route="configuracao" icon="settings"></app-navbar-link> -->
  </ul>
</nav>
